import React from 'react';

const Pricing = () => (
  <section id="pricing" className="pricing animate">
    <h2>Pricing</h2>
    <p>Find the plan that's right for you.</p>
    <div className="pricing-grid">
      <div className="pricing-card">
      <h3>Basic Plan</h3>
        <div className="price">
        <span className="old-price">$5/month</span> <span className="new-price">FREE!</span>
        </div>
        <ul>
          <li>10,000 cells per prompt</li>
        </ul>
        <button className="cta-button">Your Current Plan</button>
      </div>
      <div className="pricing-card">
        <h3>Pro</h3>
        <div className="price">
        {/* <span className="old-price">$10/month</span> */}
         <span className="new-price">$10/month</span>
        </div>
        <ul>
          <li>15,000 cells per prompt</li>
        </ul>
        <button className="cta-button">Coming Soon</button>
      </div>
      <div className="pricing-card">
        <h3>Enterprise</h3>
        <div className="price">
        {/* <span className="old-price">$20/month</span> */}
         <span className="new-price">$15/month</span>
        </div>
        <ul>
          <li>Custom cell prompt</li>
        </ul>
        <button className="cta-button">Contact Sales</button>
      </div>
    </div>
  </section>
);

export default Pricing;